import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;

  const {data = {}, type} = jsonNode;
  const {animation = {}} = data;

  const isAnimation = type === 'Animation';
  const isOldType = !animation.hasOwnProperty('tag');

  return {
    needed: isAnimation && isOldType,
    logData: {
      msg: 'Has old pre-Union dataType animation data format',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      const {
        placeholderSrc,
        loop,
        useBuiltInDuration,
        playInReverse,
        duration,
        renderer: renderMode,
        config = {},
      } = animation as {
        placeholderSrc: string;
        loop: boolean;
        useBuiltInDuration: boolean;
        playInReverse: boolean;
        duration: number;
        renderer: 'svg' | 'canvas';
        config: {
          path: string;
          origFileName: string;
          totalDuration: number;
        };
      };

      const {
        path: src,
        origFileName,
        totalDuration,
      } = config as {
        path: string;
        origFileName: string;
        totalDuration: number;
      };

      if (placeholderSrc) {
        data.animation = {
          tag: 'lottie',
          val: {placeholderSrc},
        };
        return;
      }

      const val: {
        path: {
          src: string;
          origFileName: string;
          totalDuration: number;
        };
        loop?: boolean;
        duration?: number;
        playInReverse?: boolean;
        renderMode?: 'svg' | 'canvas';
      } = {
        path: {
          src,
          origFileName,
          totalDuration,
        },
        renderMode: renderMode || 'svg',
        loop: Boolean(loop),
        playInReverse: Boolean(playInReverse),
      };

      if (duration !== undefined && !useBuiltInDuration) {
        val.duration = duration;
      }

      data.animation = {
        tag: 'lottie',
        val,
      };
    },
  };
};
